import LzMedia from '../../components/commons/media';
import { lzInitials } from '../../services/LzStrings';
import LzCrudModelField from "./field";

/**
 * LzCrudModelInput class
 */
export default class LzCrudModelInput {

    static TYPE_STATIC = 'static';
    static TYPE_TEXT = 'text';
    static TYPE_TEXTAREA = 'textarea';
    static TYPE_RICHEDITOR = 'richeditor';
    static TYPE_EMAIL = 'email';
    static TYPE_NUMBER = 'number';
    static TYPE_PASSWORD = 'password';
    static TYPE_COLOR = 'color';
    static TYPE_DATE = 'date';
    static TYPE_SWITCH = 'switch';
    static TYPE_SELECT = 'select';
    static TYPE_TAGS = 'tags';
    static TYPE_MEDIA = 'media';

    /**
     * Constructor to initialize
     * 
     * @param {*} model 
     * @param {LzCrudModelField} field 
     * @param {boolean} isView 
     */
    constructor(model, field, isView) {
        if (!model) {
            model = {};
        }
        if (!field) {
            field = { required: false, default: '' };
        }

        this.label = model.label ? model.label : '';
        this.icon = model.icon ? model.icon : '';

        if (model.type) {
            this.type = model.type;
        } else if (isView) {
            this.type = LzCrudModelInput.TYPE_STATIC;
        } else if (field.type === LzCrudModelField.TYPE_REFERENCE) {
            this.type = LzCrudModelInput.TYPE_SELECT;
        } else if (field.type === LzCrudModelField.TYPE_MEDIA) {
            this.type = LzCrudModelInput.TYPE_MEDIA;
        } else if (field.type === LzCrudModelField.TYPE_NUMBER) {
            this.type = LzCrudModelInput.TYPE_NUMBER;
        } else {
            this.type = LzCrudModelInput.TYPE_TEXT;
        }

        this.InputComponent = model.InputComponent; // the full input component
        // this component must have defined a model prop and an onChange(changes) event

        this.subType = model.subType ? model.subType : '';
        this.gridMd = model.gridMd ? +model.gridMd : 4;
        this.gridSm = model.gridSm ? +model.gridSm : 6;
        this.hintText = model.hintText ? model.hintText : '';
        this.disabled = !!model.disabled;
        this.translatable = typeof model.translatable === 'boolean' ? model.translatable : !!field.translatable;
        this.required = typeof model.required === 'boolean' ? model.required : isView ? false : field.required;
        this.default = model.default ? model.default : field.default;
        this.options = model.options ? model.options : field.options;
        this.displayFunction = LzCrudModelInput.getDisplayFunction(model, field);
        this.isVisibleFunction = model.isVisibleFunction ? model.isVisibleFunction : () => true;
        this.onChange = model.onChange ? model.onChange : null;
        this.mediaParams = model.mediaParams;
        this.isMedia = !!model.mediaParams; // save as a class var instead of making a getter because later this.mediaParams could be initialized to something and then it will not remain null
        this.extraParams = model.extraParams;
        this.getExtraParams = model.getExtraParams ? model.getExtraParams : () => this.extraParams;
    }

    /**
     * Get the display function.
     * 
     * @param {*} model 
     * @param {LzCrudModelField} field 
     */
    static getDisplayFunction(model, field) {
        if (model && model.displayFunction) {
            return model.displayFunction;
        }

        if (field.type === LzCrudModelField.TYPE_REFERENCE && field.refAppendedDisplayField !== '') {
            return (val, record) => record[field.refAppendedDisplayField] ? record[field.refAppendedDisplayField] : (val === 0 ? '' : val);
        }

        if (model.type === LzCrudModelInput.TYPE_SWITCH) {
            return (val) => val ? 'Yes' : 'No';
        }

        if (field.type === LzCrudModelField.TYPE_MEDIA) {
            return (val, record) => {
                const altField = model?.mediaParams?.altFieldName || '';
                const altValue = '' === altField ? '' : record[altField] || '';
                const initials = '' === altValue ? '' : lzInitials(altValue);

                return <LzMedia
                    avatar={!!model?.mediaParams?.avatar}
                    avatarInitials={initials}
                    altText={altValue}
                    imgSrc={val ? val.file_preview_path : ''}
                    className="lz-avatar-large lz-card-media-small"
                />;
            };
        }

        return (val) => val;
    }

    static parseData(data, fields, isView) {
        const out = {};

        if (!data) {
            return out;
        }

        const keys = Object.keys(data);
        for (const key of keys) {
            out[key] = new LzCrudModelInput(data[key], fields ? fields[key] : null, isView, key);
        }

        return out;
    }

}
